export default [
    {
        path: '/banks',
        name: 'banks',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Banks.vue')
    }
]